export default [
  {
    path: '/competitors/products',
    name: 'competitors.products.index',
    component: () => import('@/views/competitors/products/Index.vue'),
    meta: {
      pageTitle: 'Products',
      breadcrumb: [
        {
          text: 'Products',
          active: true,
        },
      ],
      action: 'read',
      resource: 'Competitors',
    },
  },
  {
    path: '/competitors/brands',
    name: 'competitors.brands.index',
    component: () => import('@/views/competitors/brands/Index.vue'),
    meta: {
      pageTitle: 'Brands',
      breadcrumb: [
        {
          text: 'Brands',
        },
      ],
      action: 'read',
      resource: 'Competitors',
    },
  },
  {
    path: '/competitors/connections',
    name: 'competitors.connections.index',
    component: () => import('@/views/competitors/connections/Index.vue'),
    meta: {
      pageTitle: 'Connections',
      breadcrumb: [
        {
          text: 'Connections',
        },
      ],
      action: 'read',
      resource: 'Competitors',
    },
  },
]
